export const KNOWLEDGE_BRANDS = [
  ['KLEDA', 'Kleda'], ['CINCO', 'Cinco'], ['SOFASAVER', 'SofaSaver'],
  ['SCHOONHUISSHOP', 'Schoonhuisshop'], ['VLOERKLEEDREINIGEN', 'Vloerkleedreinigen.com'],
  ['BANKREINIGEN', 'Bankreinigen.nl'],
] as const;

export const KNOWLEDGE_CATEGORIES: Record<string, string> = {
  diensten: 'Diensten & mogelijkheden', 'prijzen-pakketten': 'Prijzen & pakketten',
  'plannen-verplaatsen': 'Voortgang & planning', 'ophalen-bezorgen': 'Ophalen & bezorgen',
  'reiniging-materialen': 'Reiniging & materialen', 'vlekken-geur': 'Vlekken & geur',
  onderhoud: 'Onderhoud thuis', reparatie: 'Reparaties', 'betalen-facturen': 'Betalen & facturen',
  'klachten-garantie': 'Klachten & garantie', 'producten-bestellen': 'Producten & bestellen',
  'verzenden-retourneren': 'Verzending & retour', 'machine-gebruik': 'Machine gebruiken',
  'contact-merkrelaties': 'Contact & onze merken',
  bronconflicten: 'Open beleidsvragen',
};

export interface KnowledgeSource { type?: string; ref: string; label?: string; checked_at?: string }
export interface KnowledgeArticle {
  id: string; revision: number; brand: string; titel: string; antwoord: string;
  vraag_patronen?: string; categorie?: string | null; publiek?: boolean; leesklasse?: string;
  owner_key?: string | null; source_refs?: unknown; reviewed_at?: string | null; review_door?: string | null;
  review_due_at?: string | null; geldig_vanaf?: string | null; geldig_tot?: string | null; updated_at?: string | null;
}

export function brandLabel(brand: string): string {
  return KNOWLEDGE_BRANDS.find(([key]) => key === brand)?.[1] ?? (brand === 'ALL' ? 'Gedeelde kennis' : brand);
}
export function categoryLabel(category?: string | null): string {
  return category ? KNOWLEDGE_CATEGORIES[category] ?? category.replace(/[-_]/g, ' ') : 'Algemeen';
}
export function reviewLabel(article: KnowledgeArticle): string {
  return article.review_door === 'codex-source-review' ? 'Broncontrole door Codex' : 'Beoordeeld';
}
export function knowledgeSources(value: unknown): KnowledgeSource[] {
  if (!Array.isArray(value)) return [];
  return value.flatMap((source) => {
    if (typeof source === 'string') return [{ ref: source }];
    if (!source || typeof source !== 'object') return [];
    const ref = typeof source.ref === 'string' ? source.ref : typeof source.url === 'string' ? source.url : typeof source.path === 'string' ? source.path : '';
    return ref ? [{ ...source, ref }] : [];
  });
}
export function knowledgeDate(value?: string | null): string {
  if (!value) return 'Nog niet vastgelegd';
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? 'Onbekend' : date.toLocaleDateString('nl-NL', { day: 'numeric', month: 'short', year: 'numeric' });
}
export function articleExcerpt(text: string, max = 210): string {
  const first = text.replace(/^#{1,6}\s+.*$/gm, '').trim().split(/\n\s*\n/)[0] ?? '';
  const plain = first.replace(/\[([^\]]+)\]\([^)]+\)/g, '$1').replace(/[*_`]/g, '').replace(/\s+/g, ' ').trim();
  return plain.length > max ? plain.slice(0, max).replace(/\s+\S*$/, '') + '…' : plain;
}
export async function knowledgeApi<T>(url: string, init?: RequestInit): Promise<T> {
  const { supabase } = await import('./supabase');
  const { data: { session } } = await supabase.auth.getSession();
  if (!session?.access_token) throw new Error('Je sessie is verlopen. Log opnieuw in.');
  const response = await fetch(url, { ...init, headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${session.access_token}`, ...init?.headers } });
  const body = await response.json().catch(() => null);
  if (!response.ok) throw new Error(body?.error ?? `Laden mislukt (${response.status}). Probeer opnieuw.`);
  if (body === null) throw new Error('De kennisbank gaf geen geldig antwoord. Probeer opnieuw.');
  return body as T;
}
